// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"ModeloGpsTable_spinnerContainer__SuK0U","botonAdd":"ModeloGpsTable_botonAdd__pDcVq"};